import {IResource} from '@simpli/resource-collection/dist/types/IResource'
import {Request} from '@simpli/serialized-request'
import {BlockchainVersion} from '@/model/resource/BlockchainVersion'
import {OrbitRound} from '@/model/resource/OrbitRound'

export class OrbitTransaction implements IResource {
  idOrbitTransactionPk: number = 0

  blockchainVersion: BlockchainVersion | null = null
  orbitRound: OrbitRound | null = null

  address: string | null = null
  eventname: string | null = null
  transactionHash: string | null = null
  createdAt: Date | null = null
  updatedAt: Date | null = null

  get $id() {
    return this.idOrbitTransactionPk
  }

  get $tag() {
    return String(this.idOrbitTransactionPk)
  }

  /**
   * Persists a new instance of OrbitTransaction. Use ID = 0 to create a new one,
   * or ID > 0 to update a current one
   */
  async persistOrbitTransaction() {
    return await Request.post(`/client/orbit-transaction`, this)
      .name('persistOrbitTransaction')
      .asNumber()
      .getData()
  }
}
